module.exports = __webpack_public_path__ + "static/savings_chart_updated-1bb150c89132f7141997e00379a8c95e.png";